// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2xmg2","log":"ModalInventoryLogs_log__3jfKX","date":"ModalInventoryLogs_date__3U70n","userName":"ModalInventoryLogs_userName__1nGRu"};